<p>
  Leider ist ein technisches Problem aufgetreten:
</p>
<p>
  {{errorMessage}}
</p>
<p>
  Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.
  Sollte das Problem weiterhin auftreten, wenden Sie sich bitte
  per Mail an <a href="mailto:info@spr-plus.ch">info@spr-plus.ch</a>.
</p>

<div class="buttonRow">
  <button (click)="appController.previous()">Zurück</button>
</div>
